export const formatTAJ = (tajNumber: string): string =>
  tajNumber.length === 9
    ? tajNumber.substring(0, 3) +
      ' ' +
      tajNumber.substring(3, 6) +
      ' ' +
      tajNumber.substring(6, 9)
    : tajNumber

// validate end extract taj number from string
export const parseTajNumber = (tajString: string): false | string => {
  const inputDigits = (tajString.match(/\d+/g) || []).join('').split('')
  const cdvCode =
    [...inputDigits.slice(0, 8)].reduce(
      (acc, item, index) => acc + Number(item) * (index % 2 !== 0 ? 7 : 3),
      0
    ) % 10
  return inputDigits.length === 9 && Number(inputDigits[8]) === cdvCode
    ? inputDigits.join('')
    : false
}
